import { render, staticRenderFns } from "./FormTermsConditionsQuestion.vue?vue&type=template&id=2c0fbdf4"
import script from "./FormTermsConditionsQuestion.vue?vue&type=script&lang=js"
export * from "./FormTermsConditionsQuestion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports